import React, { useEffect, useState } from 'react'
import ApiGo from '../../../../actions/ApiGo'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TimeSelector from './TimeSelector';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import UiIntegrater from '../littleUIComponent/UiIntegrater'
import { HR, RR } from './SVGRRHR';
import ConfigHandler from '../../../../actions/ConfigHandler';
import { ADD_RESPONSE } from '../../../../stores/reducer_add';

const HISVitalRow = (props) => {
    const isHR = ConfigHandler.isShowCF()
    const { t } = useTranslation()

    const store_timestamp = useSelector(state => state.store_historyData.timestamp)
    const store_start = useSelector(state => state.store_historyData.timestampBegin)
    const store_end = useSelector(state => state.store_historyData.timestampEnd)

    const dispatch = useDispatch()

    const [timeSelector, setTimeSelector] = useState(false);
    const [breathRow, setBreathRow] = useState([]);
    const [heartRow, setHeartRow] = useState([]);

    const [start, setStart] = useState(Number(store_start) || 0);
    const [end, setEnd] = useState(Number(store_end) || 0);
    const [timeInterval, setTimeInterval] = useState([0, 0]);
    const [reset, setReset] = useState(false);

    const getTZOffset = () => (8 * 60 + new Date().getTimezoneOffset()) * 60000;
    const tzOffset = getTZOffset()

    function toggoleTimeSelctor() {
        setTimeSelector(!timeSelector)
    }

    function toggleReset(timeStart, timeEnd) {
        const parsedStart = timeStart ? Date.parse(timeStart.replace(/-/g, '/')) : Date.now();
        const parsedEnd = timeEnd ? Date.parse(timeEnd.replace(/-/g, '/')) : Date.now();

        // 防呆：確保轉出來不是 NaN 之後才寫入
        setStart(!isNaN(parsedStart) ? parsedStart : Date.now());
        setEnd(!isNaN(parsedEnd) ? parsedEnd : Date.now());

        setTimeInterval([timeStart, timeEnd])
        setReset(true)
    }

    const formatTime = (ts) => {
        if (!ts || isNaN(ts)) return "--"
        return new LogTime(new Date(Number(ts) + tzOffset))
            .getFullTime_withoutSec_and_Millsec()
    }

    // 🔹 初始 / redux 更新
    useEffect(() => {
        if (!store_start || !store_end) return

        const _start = Number(store_start)
        const _end = Number(store_end)

        setStart(_start)
        setEnd(_end)

        const _date_obj = new Date(_end + tzOffset)
        const _date_obj_previous = new Date(_start + tzOffset)

        const _date_previous = new LogTime(_date_obj_previous).getFullTime_withoutMillsec()
        const _date = new LogTime(_date_obj).getFullTime_withoutMillsec()

        ApiGo.getVital_Curve(props.data.id, _date_previous, _date)
            .then(res => {
                let hr = []
                let rr = []
                res.forEach(r => {
                    if (r.type === "hr") hr.push(r)
                    if (r.type === "rr") rr.push(r)
                })
                setBreathRow(rr);
                setHeartRow(hr)
            })
            .catch(err => {
                dispatch(ADD_RESPONSE({
                    status: err.status,
                    statusText: err.statusText,
                    type: "hisRec_no_data"
                }))
                setBreathRow([]);
                setHeartRow([]);
            })

    }, [store_timestamp, store_start, store_end])

    // 🔹 手動選時間
    useEffect(() => {
        if (!reset) return

        // if (!timeInterval[0] || !timeInterval[1]) return
        if (!timeInterval || !timeInterval[0] || !timeInterval[1]) {
            setBreathRow([]);
            setHeartRow([]);
            setReset(false);
            return;
        }

        setReset(false);

        ApiGo.getVital_Curve(props.data.id, timeInterval[0], timeInterval[1])
            .then(res => {

                if (!Array.isArray(res)) return;

                let hr = []
                let rr = []
                res.forEach(r => {
                    if (r.type === "hr") hr.push(r)
                    if (r.type === "rr") rr.push(r)
                })
                setBreathRow(rr);
                setHeartRow(hr)
            })
            .catch((err) => {
                setBreathRow([]);
                setHeartRow([]);
            });
        // .catch(() => {
        //     setBreathRow([]);
        //     setHeartRow([]);
        // })
        // .finally(() => {
        //     setReset(false)
        // })

    }, [reset, timeInterval])

    return (
        <>
            <UiIntegrater
                OnOff_switch={[true, false, false, true, true]}
                date={new Date()}
                name={props.data?.last_name || ""}
                bed={props.data?.first_name || ""}
            />

            <div className="fx-d-c h-90">
                <div className="fx-d-r fx-fsc timeslecMobile h-5 timePresent frame" onClick={toggoleTimeSelctor}>
                    <div className="br-10 time_pink fx-ccc w-20 cursor pt h-100">
                        {t("HISTORY_RECORD.TIME_SELECT")}
                    </div>

                    {timeSelector &&
                        <TimeSelector
                            hide={toggoleTimeSelctor}
                            toggleReset={toggleReset}
                            setTimeInterval={setTimeInterval}
                        />
                    }

                    <div className='timeslecMobile fx-d-r fx-cspar content'>
                        {t("HISTORY_RECORD.CHOSEN_TIME")} &nbsp; : &nbsp;
                        {formatTime(start)}
                        &nbsp;&nbsp; - &nbsp;&nbsp;
                        {formatTime(end)}
                    </div>
                </div>

                <div className="font-ml frame-title _1 pad-5 t vitalRow">
                    <div className="col-m fx-ccc row_title">{t('GLOBAL.DATE')}</div>
                    <div className="col-m fx-ccc row_title">{t('GLOBAL.TIME')}</div>
                    <div className="col-m fx-ccc row_title">{t("HISTORY_RECORD.BREATH_FREQUENCY")}</div>
                    <div className="col-m fx-ccc row_title">{t("HISTORY_RECORD.MA")}</div>
                    {isHR && <>
                        <div className="col-m fx-ccc row_title">{t("HISTORY_RECORD.AVG_HEART")}</div>
                        <div className="col-m fx-ccc row_title">{t("HISTORY_RECORD.MA")}</div>
                    </>}
                </div>

                <div className='frame-table'>
                    <VitalRow breathData={breathRow} heartData={heartRow} />
                </div>
            </div>
        </>
    );
}

export default HISVitalRow;

const VitalRow = ({ breathData, heartData }) => {
    const isHR = ConfigHandler.isShowCF()
    const { t } = useTranslation()

    return (
        <div className='max-hig-withTimeSelector'>
            {breathData.map((row, index) =>
                <div key={row.id} className="font-ml cardDefaultCF his vitalRow">
                    <div className="col-m fx-ccc row_body odd">{row.created_at.split('T')[0]}</div>
                    <div className="col-m fx-ccc row_body even">{row.created_at.split('T')[1]}</div>

                    <div className="col-m fx-ccc row_body br">
                        <RR type="icon_pic" />
                        &nbsp;&nbsp;
                        {row.average} {t("HISTORY_RECORD.TIMES_MIN")}
                    </div>

                    <div className="col-m fx-ccc row_body br">
                        {row.moving_average} {t("HISTORY_RECORD.TIMES_MIN")}
                    </div>

                    {isHR && heartData[index] &&
                        <>
                            <div className="col-m fx-ccc row_body hr">
                                <HR type="icon_pic" />
                                &nbsp;&nbsp;
                                {heartData[index].average} {t("HISTORY_RECORD.TIMES_MIN")}
                            </div>

                            <div className="col-m fx-ccc row_body hr">
                                {heartData[index].moving_average} {t("HISTORY_RECORD.TIMES_MIN")}
                            </div>
                        </>
                    }
                </div>
            )}
        </div>
    );
}